export default "__VITE_ASSET__c7f33518__"